import { env, Runtime } from './env';

const aiIconBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAEmElEQVRoBe2ZX0jUWRTHmxmnNDdLJ7XtH6TmCL6IUmxU1FMsBtVDhmxG7FOxkcu6D7tLFFawb+FWD0rtFpH7sOjuVliRu8S8uBOISYRLikoPKy1ToKwLOso4+zm/5splcH6/3+w44xRz4c49988553vuOb/7u78zy5ZlytLugGOx1VdWVq4LBoPeubm59Q6HQ+oK6Fe0r1wu18uhoaEXi6lzUQzwer1bQqFQPUAPAW4b1UzuS4y5S/1peHjYn6gxZoosZZeVlRWGw+GzLDxJ67ZkiFqAEQ/g+3p0dPR51JTtrsv2yqiFgG9AeTd1N1PzcgA1Q99P20PtpvqcTucwYwFqATWHqspWiBMej2dlY2PjY5/PF1YTdtu4PdDc3Oxsb2//lnD5SlcC0Mf0r9E+JDT+0ecUXVdX5+rv798N7zHGjlPnDYfucrvdnwwODk6q9XbauA0oKSm5jeAGJRzAf1KbAP1Ijdlpy8vLK3huWvDgx9r63uLi4j1+v39KGzMlnaazUZOEzTcM6eB/zc3N3R4veBErpxF8tRh/UVOzLRAI/KD1LUnbHmDna5HWRVU8rSMjI6cAEHfcRqNC9knGWrXxL3iwv9P6MUlbHqipqXED9DJSFPjfGTu9GOAFGWDbkHVFQ9lcUVHh0foxSVsGTExMnCBWy0QKit4QNkc6OjpCMaX+j4nq6uomZA9EWFfPzMycsSNG7WjMtXJy9PX1jbGgWBah5HNCR9+tmLzxThBK++GRMBU9waysrEKrU8nSAxx7u5CnwI9lZ2e3iYJkFELpPsCfimw8voJTSj+hFlRpaQBn9kGN8+eBgQF5USWz/KKER64mqrtga2kAO7JP47yr0Ukh2fl7muCdGr0gaWkAXJsVJzHZq+hktfn5+XJbNY5mNm89Bpk+p6aTXI0/mJqaMl7tCPuXh3dVsoDrcktLSwMAL5Qx7lFFvPBe6/M6nSUdXusbiLcdkYm/YHgiNOA/jIxJ87dGJ5t8gwLDADZuLbRhADeBj6A3inIM8/M2HzMMEPDUDpmAQdojQrPIzbiQUpL98L7V8vZ3/u2uhxB0E7UuslDaTjvPgC447eiMAUvtkowHMh5IcAcyIZTgBibMnvFAwluYoIB33gPGXchkE15zHzofmZfMWtoV0+v0UqDlxnmMC+RNdBtZO/ku5tYpt9MFS1qFEN8BpwF/C6QGeG7Gj8zAi0VpYwDgz3JVlmyHiopnGCA5VNOSFgaQTrkE+AsKKcD/yMvL22v2JabWGq5SnVS3knOanp7+Hr2fabq7+S7eTzrHVpZauUvjTw3J9/ZyPll/RNthTWNnTk7O0XhSN0sSQuRVV7Lzkj7Rwd9gvD4e8GJ4yj1QVVW1ZnJysouY13M+LWQ8viT257+FNa+Ykik1gJOmCODyR0iVQgXoc4DX/yNQU7balBnASSMJst+o5RFkYcBLoviqLaQxFqXkFOJvWC877wNDSQRHCPCfAv56DFy2h63uQrYFmS2cnZ2V/483yRqAB2nqAX9H+omWlHhgfHy8p6CgwAP4SjxxgDT6w0SBp5wf4A6eA/lfOFPeqx34D3XNg8KB3Z3+AAAAAElFTkSuQmCC';
const maoyanActivityGroupName = 'act_maoyan_group_new';
const lowCarbonActivityGroupName = 'act_lowcarbon_group_new';
const maicaiActivityGroupName = 'act_maicai_group_new';
const dandanleActivityId = '754468118603000000';
const lotteryActivityId = '652629868570000000';
const groupNameMapForHorn = {
  act_lowcarbon_group_new: 'lowcarbon',
  act_maicai_group_new: 'maicai',
  act_maoyan_group_new: 'maoyan'
};
// 约定返现活动
const cashbackActivityId = '62259497807904';
// 约定返现中行双端升级活动
const cashbackUpgradeId = '231121594703831114000000';
// 约定返现中行双端开通钱包快付活动
const cashbackOpenWalletId = '230928612986961990000000';
// 跳转数字人民币App scheme配置
const dcepAppConfig = {
  appId: {
    package: 'cn.gov.pbc.dcep',
    scheme: 'dcep://uniwallet/startApp', // 有业务功能带参数用这个scheme，比如一键反绑
    commonLink: 'dcep://uniwallet/startApp/commonLink?uniwallet_biz=main' // 不带任何业务功能时用这个scheme(不区分ios和Android)
  },
  jumpToAppAndriodScheme: 'dcep://uniwallet',
  downloadUrl: {
    iosUrl: 'itms-apps://itunes.apple.com/us/app/apple-store/id1571652872',
    androidUrl: 'https://pilot.app.ecny.pbcdci.cn/download/index.html?disableAppStoreDefaultPage=1'
  },
  bindWalletScheme: 'dcep://uniwallet/startApp'
};

// 建行钱包升级活动name
export const walletUpdateActivityName = 'ccb_upgrade_activity_group';
// 建行钱包升级活动id
export const walletUpdateActivityId = (env.runtime === Runtime.Test || env.runtime === Runtime.Local) ? '878443462694000001' : '445121159237000000';

export {
  aiIconBase64,
  lowCarbonActivityGroupName,
  maicaiActivityGroupName,
  maoyanActivityGroupName,
  groupNameMapForHorn,
  dcepAppConfig,
  dandanleActivityId,
  lotteryActivityId,
  cashbackActivityId,
  cashbackUpgradeId,
  cashbackOpenWalletId
};
